"use strict";
/**
 * The applications module provides access to the applications data from the EVA back-end
 * @preferred
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
var service_1 = require("../service");
/**
 * Provides access to an order available in EVA
 */
var Application = /** @class */ (function (_super) {
    __extends(Application, _super);
    function Application() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Application.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {};
        return _super.prototype.fetch.call(this, "GetCurrentApplication", requestData);
    };
    Application.prototype.setData = function (response) {
        this.data = response;
        return this.data;
    };
    Application.prototype.configuration = function () {
        // Create the service instance
        //
        var service = new service_1.EVAService("GetApplicationConfiguration");
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {};
        return service.call(requestData);
    };
    return Application;
}(base_1.FetchableItem));
exports.Application = Application;
